import { ShareGuideCycleStyle } from './ShareGuideCycle.styles';
import { TwoPiledSquaresIcon, ThreeLinkedDotsIcon } from '@grupoboticario/flora-react-icons';
import { copyToClipboard } from './helpers';
import { catalogButtonClick } from '../../Showcases/CycleGuide/components/events';
import { ResellerAvailableCatalogs } from 'core/services/bff';

type TShareGuideCycleFooter = {
  selectedGuide: ResellerAvailableCatalogs;
  shareClick: () => void;
};

const ShareGuideCycleFooter = ({ selectedGuide, shareClick }: TShareGuideCycleFooter) => {
  return (
    <ShareGuideCycleStyle.ModalFooterShareGuide>
      <ShareGuideCycleStyle.CopyButton
        variant="ghost"
        leftIcon={<TwoPiledSquaresIcon size={16} />}
        onClick={() => {
          copyToClipboard(selectedGuide?.link);
          catalogButtonClick(
            { ...selectedGuide, position: selectedGuide?.position },
            'click:copiar-link',
          );
        }}
        data-flora="button"
        data-flora-text="copiar"
      >
        Copiar
      </ShareGuideCycleStyle.CopyButton>
      <ShareGuideCycleStyle.ShareButton
        leftIcon={<ThreeLinkedDotsIcon size={16} />}
        data-flora="button"
        data-flora-text="compartilhar"
        onClick={shareClick}
      >
        Compartilhar
      </ShareGuideCycleStyle.ShareButton>
    </ShareGuideCycleStyle.ModalFooterShareGuide>
  );
};

export default ShareGuideCycleFooter;
